import type { AppType } from "@eca/server/app-type";
import { hc } from "hono/client";

export const client = hc<AppType>("/api");

export class ApiError extends Error {
  status: number;
  code: string;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

interface ResponseLike {
  ok: boolean;
  status: number;
  json(): Promise<unknown>;
}

type JsonOf<R> = R extends { json(): Promise<infer J> } ? J : never;

/** Awaits a typed client call; non-2xx answers become ApiError with the server's Japanese message. */
export async function unwrap<R extends ResponseLike>(call: Promise<R>): Promise<Exclude<JsonOf<R>, { error: string }>> {
  let res: R;
  try {
    res = await call;
  } catch {
    throw new ApiError(0, "network", "サーバーに接続できませんでした。通信環境をご確認ください");
  }
  if (res.status === 204) return undefined as never;
  const body = (await res.json().catch(() => null)) as { error?: string; code?: string } | null;
  if (!res.ok) throw new ApiError(res.status, body?.code ?? "error", body?.error ?? `エラーが発生しました（${res.status}）`);
  return body as Exclude<JsonOf<R>, { error: string }>;
}

export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error) return err.message;
  return "エラーが発生しました";
}
